import React, { PureComponent } from 'react';
// import ReactTooltip from 'react-tooltip'
import { useEffect, useState, useRef, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Circle, Popup, ZoomControl, Tooltip, useMap, useMapEvent, useMapEvents, LayerGroup, Polyline, GeoJSON } from 'react-leaflet'
import daimyoList from '../data/daimyolist.json';
import injectSheet from 'react-jss';
import { Scrollama, Step } from 'react-scrollama';
import '../App.css';
// import Provinces from '../geojson/province.json'

import DaimyoCategory from '../img/daimyo_category.png'


const styles = {
  description: {
    margin: '10px auto 30px',
    fontSize: 22,
    lineHeight: '28px',
    '& a': {
      color: 'black',
    },
  },
  graphicContainer: {
    padding: '20vh 0vw 20vh',
    display: 'flex',
    justifyContent: 'space-between',
  },
  graphic: {
    flexBasis: '60%',
    position: 'sticky',
    width: '100%',
    height: '60vh',
    top: '20vh',
    // backgroundColor: '#aaa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      fontSize: '5rem',
      fontWeight: 700,
      textAlign: 'center',
      color: '#fff',
    },
  },
  scroller: {
    flexBasis: '38%',
    paddingRight: '2rem'
  }
  // step: {
  //   margin: '0 2rem 3rem 2rem',
  //   padding: '180px 0',
  //   backgroundColor: '#fff',
  //   boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  //   '& p': {
  //     textAlign: 'center',
  //     padding: '1rem',
  //     fontSize: '1.5rem',
  //     margin: 0,
  //   },
  //   '&:last-child': {
  //     marginBottom: 0,
  //   },
  // }
};


class Map extends PureComponent {
  state = {
    data: 0,
    map: null,
    targetCircle: null,
    zoomLevel: 6,
    initialCenterPos: [38, 136],
    userPosition: [],
    steps: [
      {
        title: "寛政年間 諸大名の勢力図",
        description: "寛政年間(1789~1801)の全国諸大名の居城と石高をマッピングしました。",
        centerPos: [38, 136]
      },
      {
        description: "円は各大名を表し、居城を中心として、大きさは石高に比例しています。円をタップすると詳しい情報が表示されます。"
      },
      // {
      //   value: 20,
      //   description: "現在地周辺の大名配置を見てみてください。"
      // },
      {
        description: "江戸時代の大名は、将軍家との関係によって大きく3つに区分されていました。",
        image: "DaimyoCategory"
      },
      {
        value: 10,
        description: "親藩は、主に家康の子を藩祖とする藩を指します。",
        highlightFilter: {
          key: "shinso",
          value: "親藩"
        },
      },
      {
        value: 15,
        description: "親藩の中でも特に有名なのが「御三家」と呼ばれる尾張藩・紀州藩・水戸藩です。京都所司代や大坂城代といった監視役、旗本領と合わせて、関東・関西の主要エリアを徳川家の支配下に置きました。",
        highlightIds: [1, 3, 6]
      },
      {
        value: 20,
        description: "譜代は、関ヶ原の戦い以前から徳川家に仕えてきた家臣のうち、大名に取り立てられた家です。",
        highlightFilter: {
          key: "shinso",
          value: "譜代"
        },
        centerPos: [38, 136],
        zoomLevel: 6
      },
      {
        value: 30,
        description: "東海道沿いには、譜代大名が多く配置されているのがわかります。東海道をはじめとする「五街道」は、人の往来や物流を支える幹線道路であると同時に、大坂の陣や長州征伐では幕府軍の出兵ルートとしても利用されました。",
        highlightFilter: {
          key: "shinso",
          value: "譜代"
        },
        centerPos: [34.871489, 138.27486],
        zoomLevel: 9
      },
      {
        value: 40,
        description: "東海道を西に進んでみましょう。ひときわ大きな石高を誇るのが、彦根藩です。彦根は琵琶湖に面した東海道の宿場町で、陸路・海路の交通の要衝でした。幕府にとっては、仮に西国の大名が攻め上ってきた時の防衛ラインでもありました。徳川四天王の一人・井伊直政が所領を与えられ、譜代大名の中で最大の石高を誇っています。",
        centerPos: [35, 136.3],
        zoomLevel: 8,
        highlightIds: [55]
      },
      {
        value: 50,
        description: "彦根と同様に、西国に対する備えを任されたのが、津藩です。津を通る伊勢街道もまた、江戸と大阪を結ぶ主要ルートでした。藤堂家は外様大名ですが、藩祖・藤堂高虎は家康の腹心として活躍した武将です。",
        centerPos: [35, 136.3],
        zoomLevel: 8,
        highlightIds: [57]
      },
      {
        description: "このように、譜代大名を中心とする幕府の信任が厚い大名家は、経済的・軍事的に重要な場所を「点と線」で押さえるように配置されていることがわかります。また、元々は徳川家の臣下であったことから、独立した大名へと出世したとはいえ石高があまり高くないのも特徴です。"
      },
      {
        description: "ここまで、親藩・譜代を見てきました。残るは外様大名です。外様大名は、関ヶ原の戦いに前後して、徳川家に臣従した大名を指します。",
      },
      {
        value: 60,
        description: "さて、ここでもう一度全国の地図を俯瞰してみましょう。九州や東北など、江戸から遠い場所に外様大名が目立つように感じませんか？",
        highlightFilter: {
          key: "shinso",
          value: "外様"
        }
      },
    ],
    progress: 0,
  };

  // mapRef = React.createRef();

  constructor(props) {
    super(props);
    this.circleRefs = []
    this.sampleCircle = React.createRef();
    this.sampleTooltip = React.createRef();
  }

  flyTo(pos, zoom) {
    // this.setState({ position: pos, zoomLevel: zoom });
    const { map } = this.state;
    this.setState({ zoomLevel: zoom });
    if (map) map.flyTo(pos, zoom);
  }

  getCurrentLocation() {
    navigator.geolocation.getCurrentPosition(position => {
      this.userPosition = [position.coords.latitude, position.coords.longitude];
      this.flyTo(this.userPosition, 9);
    });
  }

  onStepEnter = e => {
    const { data, entry, direction } = e;
    this.setState({ data });

    // 地図を移動
    let index = this.state.steps.map(el => el.value).indexOf(data)
    if (index !== -1) {
      let centerPos = this.state.steps[index].centerPos
      let zoomLevel = this.state.steps[index].zoomLevel || 6
      let highlightIds = this.state.steps[index].highlightIds
      let highlightFilter = this.state.steps[index].highlightFilter
      console.log(highlightIds)
      if (centerPos) this.flyTo(centerPos, zoomLevel)
      if (highlightIds) highlightIds.forEach(el => {
        console.log("hello")
        this.circleRefs[el - 1].setStyle({ fillOpacity: 0.6 });
      })
      if (highlightFilter) {
        this.circleRefs.filter(el => el.options[highlightFilter.key] == highlightFilter.value).forEach(el => {
          el.setStyle({ fillOpacity: 0.6 });
        })
        this.circleRefs.filter(el => el.options[highlightFilter.key] !== highlightFilter.value).forEach(el => {
          el.setStyle({ fillOpacity: 0.1 });
        })
      }
    }

    // if (data == 20) {
    //   this.userPosition ? this.flyTo(this.userPosition, 9) : this.getCurrentLocation();
    // }

    if (data == 40) {
      // const { targetCircle } = this.state;
      // if (targetCircle) targetCircle.setStyle({ fillColor: '#fff' })
      // console.log(targetCircles)
      // setStyle((prevState) => {
      //   const newState = [...prevState];
      //   targetCircles.forEach((n) => {
      //     newState[n] = { fillColor: '#fff' }
      //   });
      //   return newState;
      // });
    }
  };

  onStepExit = ({ direction, data }) => {
    if (direction === 'up' && data === this.state.steps[0]) {
      this.setState({ data: 0 });
    }

    let index = this.state.steps.map(el => el.value).indexOf(data)
    if (index !== -1) {
      let highlightIds = this.state.steps[index].highlightIds
      if (highlightIds) highlightIds.forEach(el => {
        this.circleRefs[el - 1].setStyle({ fillOpacity: 0.25 });
      })
      let highlightFilter = this.state.steps[index].highlightFilter
      if (highlightFilter) {
        this.circleRefs.forEach(el => {
          el.setStyle({ fillOpacity: 0.25 });
        })
      }
    }

    if (data == 100) {
      this.circleRefs.filter(el => el.options.shinso !== '外様').forEach(el => {
        el.setStyle({
          fill: 1
        });
      })
    }
  };

  onStepProgress = ({ progress }) => {
    // console.log(progress)
    this.setState({ progress });
  };

  provinceStyle = {
    fill: 0,
    color: 'silver',
    weight: 1
  }

  render() {
    const { data, steps, progress, zoomLevel, initialCenterPos } = this.state;
    const { classes } = this.props;

    const sm = window.innerWidth < 640 ? true : false

    // const [date, setDate] = useState(null);
    // const [kml, setKml] = useState(null);
    // const [targetedDaimyo, setTargetedDaimyo] = useState();

    function selectColor(val) {
      switch (val) {
        case "親藩" || 1:
          return "#b7282e"
        case "譜代" || 2:
          return "#b88828"
        case "外様" || 3:
          return "#007083"
        default:
          return "#000000"
      }
    }
    function shinso(val) {
      switch (val) {
        case "親藩":
          return 1
        case "譜代":
          return 2
        case "外様":
          return 3
        default:
          return 2
      }
    }

    function SetViewOnClick({ animateRef }) {
      const map = useMapEvent('click', (e) => {
        map.setView(e.latlng, map.getZoom(), {
          animate: true,
        })
      })
      return null
    }

    return (
      <div>
        <div className={classes.graphicContainer}>
          <div id="map" className={classes.graphic}>
            {/* <p>{data}</p> */}
            {/* {console.log(data, progress)}
            {data == 20 ? "hello" : "bye"} */}
            <MapContainer whenCreated={map => this.setState({ map })} center={initialCenterPos} zoom={zoomLevel} zoomControl={false} scrollWheelZoom={false} stroke="#ff0000">
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                // url="https://cyberjapandata.gsi.go.jp/xyz/blank/{z}/{x}/{y}.png"
                url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
              // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {/* <FullscreenControl position="bottomleft" /> */}
              <ZoomControl position="topleft" />
              {/* <LayerGroup id="lg1">
                {kml && <ReactLeafletKml kml={kml} />}
              </LayerGroup> */}
              {/* <SetViewOnClick showRef={showRef} /> */}
              {/* <GeoJSON ref="ProvinceData" style={this.provinceStyle} attribution="&copy; credits due Shiba Emiko ESRIジャパン株式会社" data={Provinces.features} /> */}
              {daimyoList.map((el, index) => {
                return (
                  <Circle
                    key={index}
                    name={el['大名当主名（現代通称）']}
                    id={el.ID}
                    shinso={el['親疎（藩翰譜）']}
                    ref={(circleRef) => this.circleRefs[index] = circleRef} 
                    center={[el['緯度'], el['経度']]}
                    radius={Math.sqrt(el['領知高（単位:石）'] / Math.PI) * 80}
                    stroke={false}
                    fillOpacity={0.25}
                    fillColor={selectColor(el['親疎（藩翰譜）'])}
                  >
                    <Tooltip className="CustomTooltip" direction="top" offset={[0, -20]}>
                      <div className="flex">
                        <span className="font-bold text-lg text-black mr-2">{el['藩名（現代通称）']}藩</span>
                        <div className="py-1">
                          <span className="px-2 py-1 rounded text-white font-bold" style={{ backgroundColor: selectColor(el['親疎（藩翰譜）']) }}>{el['親疎（藩翰譜）']}</span>
                        </div>
                      </div>
                      当主 : {el['大名当主名（現代通称）']}<br />
                      居城 : {el['居城地（武鑑表記）']}<br />
                      石高 : {el['領知高（単位:石）'] === 88888 ? "-" : el['領知高（単位:石）'] / 10000 + '万石'}<br />
                    </Tooltip>
                  </Circle>
                )
              })}
              <Tooltip ref="sampleTooltip" className="CustomTooltip" direction="top" offset={[0, -20]}>hello
              </Tooltip>
              <SetViewOnClick />
            </MapContainer>
          </div>
          <div className={classes.scroller}>
            <p class="text-center text-white text-6xl">第1編</p>
            <Scrollama
              onStepEnter={this.onStepEnter}
              onStepExit={this.onStepExit}
              progress
              onStepProgress={this.onStepProgress}
              offset="400px"
              // debug
            >
              {steps.map(el => {
                const isVisible = el.value === data;
                const visibility = isVisible ? 'visible' : 'hidden';
                return (
                  <Step class="border bg-gray-400 py-20 my-20" data={el.value} key={el.value}>
                    <div class="step-wrapper">
                      <div class="box">
                        {/* {el.value} */}
                        {el.title && <p class="title">{el.title}</p>}
                        <p>{el.description}</p>
                        {el.image == "DaimyoCategory" && <img class="pt-10 mx-auto" src={DaimyoCategory} />}
                      </div>
                    </div>
                  </Step>
                );
              })}
            </Scrollama>
          </div>
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(Map);


// https://stackoverflow.com/questions/64665827/react-leaflet-center-attribute-does-not-change-when-the-center-state-changes